// Constants
export const relationships = {
  CHILD: 'Child',
  EMPLOYEE: 'Employee',
  SPOUSE: 'Spouse',
  DOMESTIC_PARTNER: 'Domestic Partner',
  CHILD_OF_DOMESTIC_PARTNER: 'Child of Domestic Partner',
}

export const carriersName = [
  'UHC',
  'United HealthCare',
  'United Heathcare',
  'UnitedHealthcare',
].map((_name) => _name.toLowerCase())
